import type { Attachment } from "@api";

export const getAttachmentType = (
  a: Attachment & { height?: number; width?: number },
) => {
  if (!a.file) return null;

  return a.file.toLowerCase().endsWith("mp4")
    ? "video"
    : /\.(png|jpg|jpeg|avif|gif|svg|webp)$/i.test(a.file)
      ? "image"
      : null;
};

/** @returns A code based on the companyName (3 letters at most). */
export const generateCompanyCode = (companyName: string) => {
  let code = companyName.trim().replace(/[^a-zA-Z]/g, "");
  const upperCaseChars = code.match(/[A-Z]/g) ?? [];
  if (upperCaseChars.length > 2) {
    code = upperCaseChars.join("");
  }
  return code.slice(0, 3).toUpperCase();
};
